module.exports = __webpack_public_path__ + "img/Сursor-filled.3c910949.svg";